/**
 * Propaga o nonce de CSP (gerado por request no servidor e injetado na meta
 * tag csp-nonce do index.html) para os pontos que injetam <style> em runtime.
 *
 * A CSP do portal não permite mais 'unsafe-inline' em style-src; estilos
 * dinâmicos só são aceitos com o nonce da request. O Vuetify recebe o nonce
 * via options.cspNonce, mas bibliotecas sem suporte a nonce (ex.: FullCalendar)
 * injetam <style> direto no <head> — o patch abaixo carimba o nonce nesses
 * elementos antes da inserção no DOM.
 *
 * IMPORTANTE: este módulo precisa ser importado antes dos plugins/libs que
 * injetam estilos (primeiro import do main.ts).
 */

function readNonce(): string {
  const meta = document.querySelector('meta[name="csp-nonce"]')
  if (meta instanceof HTMLMetaElement && meta.content && meta.content.indexOf('__') !== 0) {
    return meta.content
  }
  return ''
}

const cspNonce = readNonce()

if (cspNonce) {
  // Nonce usado pelo runtime do webpack ao injetar tags de script/link de chunks
  // eslint-disable-next-line no-underscore-dangle
  ;(window as any).__webpack_nonce__ = cspNonce

  const patchInsertion = (proto: any, method: string) => {
    const original = proto[method]
    // eslint-disable-next-line func-names
    proto[method] = function (...args: any[]) {
      const node = args[0]
      if (node && node.nodeName === 'STYLE' && !node.nonce) {
        node.nonce = cspNonce
      }
      return original.apply(this, args)
    }
  }

  patchInsertion(Node.prototype, 'appendChild')
  patchInsertion(Node.prototype, 'insertBefore')
}

export default function getCspNonce(): string {
  return cspNonce
}
